import { Card, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import '../../../../styles/pages/seller/_return-detailCancel.scss';
import '../../../../styles/abstracts/_variables.scss';
import CancelOrder from './CancelOrder';
import CancelProduct from './CancelProduct';
import CancelStock from './CancelStock';
import { useLocation } from 'react-router';

const Breadcrumb = [
  {
    tittle: '반환/폐기 관리',
    url: ''
  },
  {
    tittle: '반환/폐기 요청',
    url: ''
  }
];

const ReturnDetailCancel = () => {
  const [tab, setTab] = useState('2');
  const [tabActive, setTabActive] = useState('2');
  const data = [
    { title: '입고 건', key: '2', comp: <CancelProduct tab={tab} /> },
    { title: '재고 건', key: '3', comp: <CancelStock tab={tab} /> }
  ];
  const location = useLocation();

  const tabItemClick = (key: any) => {
    setTab(key);
  };
  useEffect(() => {
    let locat: any = location.state;
    if (!!locat?.idStock) {
      setTab('3');
      setTabActive('3');
    }
    if (!!locat?.idImport) {
      setTab('2');
      setTabActive('2');
    }
  }, [location]);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card btnImport"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div className="choosenCancel">
            <p>어떤 건을 반환/폐기 하시겠습니까?</p>
            <Tabs
              activeKey={tabActive}
              onChange={(key: any) => {
                tabItemClick(key);
                setTabActive(key);
              }}
            >
              {data.map((item: any) => (
                <>
                  <Tabs.TabPane tab={item.title} key={item.key}>
                    {item.comp}
                  </Tabs.TabPane>
                </>
              ))}
              {/* <Tabs.TabPane tab="주문 건" key="1">
                <CancelOrder />
              </Tabs.TabPane>
              <Tabs.TabPane tab="입고 건" key="2">
                <CancelProduct />
              </Tabs.TabPane>
              <Tabs.TabPane tab="재고 건" key="3">
                <CancelStock />
              </Tabs.TabPane> */}
            </Tabs>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ReturnDetailCancel;
